import { CancellationReasonType } from 'common/billing/interfaces/cancellationReasons'

import { CancelSubscriptionStepType } from './types'

export const getModalWidth = (
  step: CancelSubscriptionStepType,
  reason: CancellationReasonType | null,
) => {
  const wideReasons = [
    CancellationReasonType.BAD_UNDERSTANDING,
    CancellationReasonType.BAD_RESULT,
    CancellationReasonType.BAD_PRODUCT,
  ]

  if (step === CancelSubscriptionStepType.WHAT_LOSES) {
    return 800
  }

  if (step === CancelSubscriptionStepType.OFFER && reason && wideReasons.includes(reason)) {
    return 800
  }

  if (step === CancelSubscriptionStepType.SELECT) {
    return 640
  }

  return 600
}
